export default __webpack_public_path__ + "static/media/project1.1a2515c8.png";